export default "__VITE_ASSET__BYV7P$6a__"